/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import * as CryptoJS from 'crypto-js';
import Clickable from '../../../components/clickable/Clickable';
import CloseIcon from '../../../icons/close.svg';
import styles from '../fields.module.scss';

class SSIField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rawSSN: this.props.answer
    };
    const { isRequired, answer, updateFieldErrors } = this.props;

    if (isRequired && !answer) {
      updateFieldErrors(['pulpoforms.errors.not_blank']);
    }
  }

  handleRemove = (index) => {
    const { answer, fieldId } = this.props;
    delete answer[index];
    this.handleAnswerChanged({ ...answer }, fieldId);
  }

  handleAdd = () => {
    const { answer, fieldId } = this.props;
    if (answer && Object.values(answer)?.filter(v => v?.trim() === '')?.length === 0) {
      this.handleAnswerChanged({
        ...answer,
        [parseInt(Object.keys(answer).pop(), 10) + 1]: ''
      }, fieldId);
    }
  }

  mask = (v) => {
    const masked = v.slice(0, 7).replace(/[0-9]/g, 'X');
    const final = masked + v.slice(7);
    return final;
  };

  // eslint-disable-next-line consistent-return
  format = (v) => {
    // eslint-disable-next-line no-param-reassign
    v = v.slice(0, 11).replace(/-/g, '');
    if (v?.length <= 3) {
      return v;
    }
    if (v?.length > 3 && v?.length <= 5) {
      return `${v.slice(0, 3)}-${v.slice(3)}`;
    }
    if (v?.length > 5) {
      return `${v.slice(0, 3)}-${v.slice(3, 5)}-${v.slice(5)}`;
    }
  };

  handleAnswerChanged(value, fieldId) {
    const {
      handleValueChange, handleFieldErrorChanged, isRequired, updateFieldErrors,
      repeat_field, user
    } = this.props;
    const { rawSSN } = this.state;
    let ciphertext = '';
    if (fieldId === 'social_security_number') {
      if (value.replace(/-/g, '')?.length < rawSSN?.length) {
        const last = rawSSN?.length - 1;
        this.setState({
          rawSSN: rawSSN.slice(0, last)
        });
        return;
      }
      let numValue = value.replace(/\D/g, '');

      let newSSN = '';
      if (rawSSN?.length > 5) {
        newSSN = rawSSN.slice(0, 5) + numValue;
      } else {
        newSSN = rawSSN + numValue;
      }
      if (newSSN?.length > 9) {
        return;
      }
      this.setState({
        rawSSN: newSSN
      });
      handleValueChange(newSSN, fieldId);
    } else {
      ciphertext = CryptoJS.AES.encrypt(JSON.stringify(value), user?.airport_metadata?.ssi_key).toString();
      handleValueChange(ciphertext, fieldId);
    }
    let updatedErrors = [];

    if (!repeat_field && (value === '' || value === undefined || value.trim() === '')) {
      handleFieldErrorChanged(fieldId, isRequired);
      if (isRequired) {
        updatedErrors = [
          ...updatedErrors,
          'pulpoforms.errors.not_blank'
        ];
      }
    } else {
      handleFieldErrorChanged(fieldId, false);
    }
    updateFieldErrors(updatedErrors);
  }


  render() {
    const {
      widget: { type: widget },
      fieldId,
      answer,
      rows,
      disabled,
      repeat_field,
      placeHolder,
      user, Badging
    } = this.props;
    let decryptedData = '';
    if (fieldId === 'social_security_number' && this.state.rawSSN !== '') {
      decryptedData = this.mask(this.format(this.state.rawSSN));
    } else if (Badging && answer) {
      decryptedData = this.mask(this.format(answer));
    } else {
    let bytes = answer && CryptoJS.AES.decrypt(answer, user?.airport_metadata?.ssi_key);
    decryptedData = bytes && JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    }
    let fieldWidget;
    if (widget === 'charfield') {
      fieldWidget = (
        <input
          type="text"
          name={`string-field-${fieldId}`}
          value={decryptedData}
          disabled={disabled}
          onChange={e => this.handleAnswerChanged(e.target.value, fieldId)}
          className="pulpo-charfield"
          placeholder={placeHolder || ''}
        />
      );
    } else {
      fieldWidget = (
        <textarea
          className="pulpo-textarea"
          name={`string-field-${fieldId}`}
          style={{ height: 'initial' }}
          value={decryptedData}
          disabled={disabled}
          onChange={e => this.handleAnswerChanged(e.target.value, fieldId)}
          rows={rows}
          placeholder={placeHolder || ''}
        />
      );
    }

    const answerValue = answer || {};

    return (
      <>
        {!repeat_field && (
          <>{fieldWidget}</>
        )}
        {repeat_field && (
          <>
            {widget === 'charfield' ? (
              <input
                type="text"
                name={`string-field-${fieldId}`}
                value={answer?.[0]}
                disabled={disabled}
                onChange={e => this.handleAnswerChanged({ ...answerValue, 0: e.target.value }, fieldId)}
                className="pulpo-charfield"
              />
            ) : (
              <textarea
                className="pulpo-textarea"
                name={`string-field-${fieldId}`}
                style={{ height: 'initial' }}
                value={answer?.[0]}
                disabled={disabled}
                onChange={e => this.handleAnswerChanged({ ...answerValue, 0: e.target.value }, fieldId)}
                rows={rows}
              />
            )}
            <div className={styles.addMargin} />
            {answer && Object.keys(answer)?.length > 1 && Object.keys(answer)?.map((key, index) => (
              <>
                {index !== 0 && (
                  <>
                    {widget === 'charfield' ? (
                      <div className={styles.repeatDisplay}>
                        <input
                          type="text"
                          name={`string-field-${fieldId}`}
                          value={answer?.[key]}
                          disabled={disabled}
                          onChange={e => this.handleAnswerChanged({ ...answer, [key]: e.target.value }, fieldId)}
                          className="pulpo-charfield"
                        />
                        <Clickable
                          className={styles.removeLink}
                          onClick={() => this.handleRemove(key)}
                        >
                          <img src={CloseIcon} alt="X" />
                        </Clickable>
                      </div>
                    ) : (
                      <div className={styles.repeatDisplay}>
                        <textarea
                          className="pulpo-textarea"
                          name={`string-field-${fieldId}`}
                          style={{ height: 'initial' }}
                          value={answer?.[key]}
                          disabled={disabled}
                          onChange={e => this.handleAnswerChanged({ ...answer, [key]: e.target.value }, fieldId)}
                          rows={rows}
                        />
                        <Clickable
                          className={styles.removeLink}
                          onClick={() => this.handleRemove(key)}
                        >
                          <img src={CloseIcon} alt="X" />
                        </Clickable>
                      </div>
                    )}
                    <div className={styles.addMargin} />
                  </>
                )}
              </>
            ))}
            <Clickable
              className={styles.addLink}
              onClick={() => this.handleAdd()}
            >
              <FormattedMessage
                id="pulpofield.string.add_more"
                defaultMessage="+ Add more"
              />
            </Clickable>
          </>
        )}
      </>
    );
  }
}


SSIField.defaultProps = {
  widget: { type: 'charfield' },
  answer: '',
  rows: 5,
  placeholder: ''
};

SSIField.propTypes = {
  widget: PropTypes.shape({ type: PropTypes.string }),
  handleValueChange: PropTypes.func.isRequired,
  fieldId: PropTypes.string.isRequired,
  answer: PropTypes.string,
  isRequired: PropTypes.bool.isRequired,
  handleFieldErrorChanged: PropTypes.func.isRequired,
  updateFieldErrors: PropTypes.func.isRequired,
  rows: PropTypes.number,
  placeholder: PropTypes.string
};

export default SSIField;
